// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MwGGnHDwXuyZX7 {
  justify-content: space-between;
  min-width: 115px;
}
.MwGGnHDwXuyZX7:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
}
.mac .MwGGnHDwXuyZX7:focus {
  outline-color: -webkit-focus-ring-color;
}
.MwGGnHDwXuyZX7:focus .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `MwGGnHDwXuyZX7`
};
export default ___CSS_LOADER_EXPORT___;
